var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { space, fontSize, borderRadius } from 'styled-system';
import themeGet from '@styled-system/theme-get';
import { ChevronDown } from 'pcln-icons';
import { borders, deprecatedColorValue, applySizes, borderRadiusAttrs } from '../utils';
import { Flex } from '../Flex';
var sizes = {
    sm: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 6px 32px 7px 12px;\n  "], ["\n    padding: 6px 32px 7px 12px;\n  "]))),
    md: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: 10px 32px 11px 12px;\n  "], ["\n    padding: 10px 32px 11px 12px;\n  "]))),
    lg: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 14px 32px 14px 12px;\n  "], ["\n    padding: 14px 32px 14px 12px;\n  "]))),
    xl: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 18px 32px 19px 12px;\n  "], ["\n    padding: 18px 32px 19px 12px;\n  "]))),
};
var ClickableIcon = styled(ChevronDown)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  pointer-events: none;\n"], ["\n  pointer-events: none;\n"])));
var propTypes = __assign(__assign(__assign({}, space.propTypes), fontSize.propTypes), { color: deprecatedColorValue() });
var SelectBase = styled.select.attrs(borderRadiusAttrs)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  appearance: none;\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  color: inherit;\n  background-color: transparent;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n\n  ", ";\n  ", " ", " ", " ", "\n  ::-ms-expand {\n    display: none;\n  }\n"], ["\n  appearance: none;\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  color: inherit;\n  background-color: transparent;\n  border-radius: ", ";\n  border-width: 1px;\n  border-style: solid;\n\n  ", ";\n  ", " ", " ", " ", "\n  ::-ms-expand {\n    display: none;\n  }\n"])), themeGet('borderRadii.lg'), function (_a) {
    var theme = _a.theme;
    return applySizes(sizes, undefined, theme.mediaQueries);
}, borders, space, fontSize, borderRadius);
SelectBase.defaultProps = {
    fontSize: [2, null, 1],
    m: 0,
    size: 'lg',
    borderRadius: 'lg',
};
SelectBase.propTypes = propTypes;
var Select = React.forwardRef(function (props, ref) { return (React.createElement(Flex, { width: 1, alignItems: 'center' },
    React.createElement(SelectBase, __assign({}, props, { ref: ref })),
    React.createElement(ClickableIcon, { ml: -32, color: 'text.light' }))); });
Select.displayName = 'Select';
Select.isField = true;
export default Select;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Select.js.map